import { createContext } from "react"

export const FilterContext = createContext({})

function FilterContextProvider(props) {
  return <FilterContext.Provider {...props} />
}

export default FilterContextProvider
